import API from "../axiosConfig";

export const getDataForPrivewMap = async () => {
  try {
    const response = await API.get("/preview-map");
    return response.data;
  } catch (error) {
    console.error("Error fetching sections:", error);
    throw error;
  }
};